// services/informe-services.js
import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api";

export const getFileTree = async () => {
  const { data } = await axios.get(`${baseUrl}${endpoint}/arbol332`);
  return data;
};

export const getReport = async () => {
  const { data } = await axios.get(`${baseUrl}${endpoint}/reporte332`);
  return data;
};

const apiService = { getFileTree, getReport };
export default apiService;
